import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * Ayarlar > Mobil Sürüm (04.11.2026, #544): mobil uygulamanın son ve en düşük (zorunlu) sürümü. Uygulama her açılışta
 * sunucuya sürümünü sorar; son sürüm boşsa kontrol yapılmaz.
 */
export const MOBIL_SURUM_SAYFASI = 'Ayarlar > Mobil Sürüm';

export interface MobilSurumItem {
    platform: 'android' | 'ios'
    platformAdi: string
    sonSurum: string | null
    enDusukSurum: string | null
    magazaAdresi: string | null
    aciklama: string | null
    guncelleyen: string | null
    guncellemeTarihi: string | null
}

export interface MobilSurumKaydet {
    platform: string
    sonSurum?: string
    enDusukSurum?: string
    magazaAdresi?: string
    aciklama?: string
}

const cagir = async (yol: string, inputObj: any) => {
    try {
        console.log('SERVICE CALL - MobilSurum/' + yol, JSON.stringify(inputObj));

        const resp = await axios.post(Helpers.getEndpoint() + '/MobilSurum/' + yol, inputObj);

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class MobilSurumService {
    static liste() { return cagir('Liste', {}); }
    static kaydet(inputObj: MobilSurumKaydet) { return cagir('Kaydet', inputObj); }
}
